import { onCleanup, onMount } from 'solid-js'
import { debounce } from '@solid-primitives/scheduled'

export function useInfiniteScroll({
	targetRef,
	onBottomReach,
	offset = 100,
	debounceMs = 200,
}: {
	targetRef: () => HTMLElement | undefined
	onBottomReach: () => void
	offset?: number
	debounceMs?: number
}) {
	// Wrap onBottomReach in a debouncer
	const debouncedReach = debounce(onBottomReach, debounceMs)

	function onScroll() {
		const el = targetRef()
		if (!el) return
		const distanceFromBottom = el.scrollHeight - el.scrollTop - el.clientHeight
		if (distanceFromBottom < offset) {
			debouncedReach()
		}
	}

	onMount(() => {
		const el = targetRef()
		if (!el) return
		el.addEventListener('scroll', onScroll)
		onCleanup(() => el.removeEventListener('scroll', onScroll))
	})
}
